<template>
  <div class="residential-account-login">
    <Card tag="form" @submit.prevent="submit" class="residential-account-login__widget">
      <template #header>
        <FontAwesomeIcon :icon="['fal', 'home']" size="2x" />
        <h1>{{ $t('residentialAccountLoginTooSeeUnits') }}</h1>
        <div class="residential-account-login__instruction">
          {{ $t('loginEnterValue', { value: $t('email').toLowerCase() }) }}
        </div>
      </template>
      <template #default>
        <div class="g-1">
          <template v-if="!isCompleted">
            <InputComponent
              v-model="data.email"
              :label="labels.email"
              required
              type="email"
              :is-valid="validator.fields.email.valid"
              :validation-message="validator.fields.email.error"
            >
              <template #below>
                <span class="residential-account-login__emailinfo">{{ $t('residentialAccountLoginCondition') }}</span>
              </template>
            </InputComponent>
            <CheckboxComponent class="residential-account-login__privacy" v-model="privacyAccepted" required>
              <i18n path="contractPrivacy" tag="span">
                <a href="/api/legal/privacy/tenant">{{ $t('privacy').toLowerCase() }}</a>
              </i18n>
            </CheckboxComponent>
          </template>
          <div v-else class="p-2 text--center">
            <strong>{{ $t('loginSuccessMessage') }}</strong>
          </div>
        </div>
      </template>
      <template #footer>
        <ButtonComponent
          :label="$t('complete')"
          :disabled="!validator.passes || !privacyAccepted || isCompleted"
          type="submit"
          theme="primary"
          :promise="promise"
          class="grow-1"
          :icon="['fal', 'angle-right']"
        />
      </template>
    </Card>
  </div>
</template>

<script>
import ContactApi from '@/api/Contact'
import Validator from '@/mixins/validator'

import { InputComponent } from 'vue-elder-input'
import Card from '@/components/Card'
import { AlertComponent as Alert } from 'vue-elder-alert'
import { CheckboxComponent } from 'vue-elder-checkbox'

export default {
  mixins: [Validator],
  props: {
    token: String,
  },
  data() {
    return {
      promise: null,
      privacyAccepted: false,
      isCompleted: false,
      data: {
        email: null,
      },
      validator: {
        rules: {
          email: 'required|email',
        },
        labels: 'labels',
        data: 'data',
      },
    }
  },
  computed: {
    labels() {
      return {
        email: this.$t('email'),
      }
    },
  },
  methods: {
    submit() {
      if (!this.validator.passes || !this.privacyAccepted) return
      this.promise = ContactApi.login(this.data).then(() => (this.isCompleted = true))
    },
  },
  metaInfo() {
    return {
      title: this.$t('residentialAccountLogin'),
    }
  },
  components: {
    Card,
    InputComponent,
    Alert,
    CheckboxComponent,
  },
}
</script>

<style lang="scss">
.residential-account-login {
  background-color: $background-grey;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  padding: 2rem;

  h1 {
    margin: 1rem 0 0 0;
    font-size: 1.5rem;
  }
  &__privacy {
    margin-top: 1.5rem;
    font-size: 0.9em;
  }
  &__emailinfo {
    font-size: 0.7em;
    margin-top: 0.5rem;
    opacity: 0.7;
  }

  &__instruction {
    opacity: 0.5;
    margin-top: 0.5rem;
    text-align: center;
  }

  &__widget {
    flex-grow: 1;
    max-width: 400px;
  }
}
</style>
